const UUID_SUFFIX_PATTERN =
  /-[0-9a-f]{8}(?:-[0-9a-f]{4}){3}-[0-9a-f]{12}(?=\.[^.]+$)/i;

const decodePathFileName = (fileName = "") => {
  if (!fileName) return "";

  try {
    return decodeURIComponent(fileName);
  } catch (error) {
    return fileName;
  }
};

const getPathFileName = (value = "") => {
  const rawValue = String(value || "").trim();
  if (!rawValue) return "";

  try {
    const fileName =
      new URL(rawValue).pathname.split("/").filter(Boolean).pop() || "";
    return decodePathFileName(fileName);
  } catch (error) {
    const fileName =
      rawValue
        .split("#")[0]
        .split("?")[0]
        .split("/")
        .filter(Boolean)
        .pop() || "";
    return decodePathFileName(fileName);
  }
};

export const deriveExportAssetFileName = (value = "") =>
  getPathFileName(value).replace(UUID_SUFFIX_PATTERN, "");

export const deriveExportAssetZipPath = (value = "") => {
  const fileName = deriveExportAssetFileName(value);
  return fileName ? `images/${fileName}` : "";
};

const escapeCssUrlValue = (value = "") =>
  String(value).replace(/\\/g, "\\\\").replace(/"/g, '\\"');

export const deriveExportAssetCssUrl = (value = "") => {
  const zipPath = deriveExportAssetZipPath(value);
  return zipPath ? `"${escapeCssUrlValue(zipPath)}"` : "";
};
